import React from 'react';
import { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../Cart Utility/CartManager';
import './CartPage.css'; // Add styles for the cart page

const CartPage = () => {
    const navigate = useNavigate(); // Use navigate for redirection
    const cart  = useContext(CartContext); 

    let tempCart = cart.items;


    const groupedCart = tempCart.reduce((acc, item) => {
        const existingItem = acc.find((cartItem) => cartItem.product_id === item.product_id);
        if (existingItem) {
            existingItem.quantity += 1;
        } else {
            acc.push({ ...item, quantity: 1 });
        }
        return acc;
    }, []);

    




    const handleRemoveItem = (id) => {

        let removetempCart = cart.items
        removetempCart = removetempCart.filter((item) => item.product_id !== id); // Remove all instances of the item
        localStorage.setItem('cart', JSON.stringify(removetempCart)); // Persist cart to localStorage
        cart.setItems(removetempCart);
        
    };

    const handleCheckout = () => {
        if (cart.items.length === 0) {
            alert('Your cart is empty. Please add items before proceeding to checkout.');
            return;
        }

        // Redirect to the checkout page
        navigate('/checkout');
    };

    return (
            <div className="cart-container">
                <h1>Your Cart</h1>
                {cart.items.length === 0 ? (
                    <p>Your cart is empty. <Link to="/">Go shopping!</Link></p>
                ) : (
                    <>
                        <div className="cart-items">
                            {groupedCart.map((item, index) => (
                                <div key={index} className="cart-item">
                                    <img
                                        src={item.images}
                                        alt={item.title}
                                        className="cart-item-image"
                                        loading="lazy"
                                    />
                                    <div className="cart-item-info">
                                        <h2>{item.title}</h2>
                                        <p>Price: ${(item.price * 1)?.toFixed(2)}</p>
                                        <p>Quantity: {item.quantity}</p>
                                        <button
                                            className="remove-item-button"
                                            onClick={() => handleRemoveItem(item.product_id)}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="checkout-actions">
                            <button className="checkout-button" onClick={handleCheckout}>
                                Proceed to Checkout
                            </button>
                        </div>
                    </>
                )}
            </div>
    );
};

export default CartPage;